import styled from 'styled-components';

type Props = {
    gridCols?: number;
};

export const Wrapper = styled.div`
    padding: 5px;

    .error-text {
        margin-top: 0;
        margin-bottom: 1rem;

        button {
            margin-left: 0.5rem;
        }
    }
`;

export const TankWrapper = styled.div`
    margin: 0 0 0 -5px;
`;
export const GridWrapper = styled.ul<Props>`
    li {
        display: grid;
        ${(props) => {
            if (props.gridCols) {
                switch (props.gridCols) {
                    case 2:
                        return `grid-template-columns: 1fr 1fr;`;
                    case 3:
                        return `grid-template-columns: 1fr 1fr 1fr;`;
                    case 4:
                        return `grid-template-columns: 1fr 1fr 1fr 1fr;`;
                    default:
                        return `grid-template-columns: 1fr 1fr 1fr 1fr 1fr;`;
                }
            } else {
                return `grid-template-columns:  1fr 1fr 1fr 1fr 1fr;`;
            }
        }};
        grid-gap: 2px;
        align-items: center;
        span {
            overflow: hidden;
            max-width: 100%;
        }
        .col-tank {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
`;
